import i18n from '@/i18n/i18n'

const { t } = i18n.global

export const COMPANY_TYPE = {
  SOLE_PROPRIETORSHIP: 1,
  LIMITED: 2,
  INCORPORATED: 3
}

export const COMPANY_TYPE_MAP = {
  1: t('constants.company_type.sole_proprietorship'),
  2: t('constants.company_type.limited'),
  3: t('constants.company_type.incorporated')
}

export const COMPANY_TYPE_DATA = [
  { id: 1, name: t('constants.company_type.sole_proprietorship') },
  { id: 2, name: t('constants.company_type.limited') },
  { id: 3, name: t('constants.company_type.incorporated') }
]
